<template>
    <h2>Все изменения сохранены!</h2>
    <h3>(страница будет перезагружена через 2 сек)</h3>
    <meta http-equiv="refresh" content="2">
</template>